// extracted by mini-css-extract-plugin
export default {"busRoute":"busRoute_busRoute__3ygg4"};